module.exports = __webpack_public_path__ + "static/media/image_case_mixiguo.31ba556b.png";